import { useIntl } from 'react-intl'
import cruiseGlossaryMessages from 'hooks/Cruise/cruiseGlossaryMessages'

function useCruiseCabinTypeLabels(): Record<string, string> {
  const intl = useIntl()

  return {
    inside: intl.formatMessage(cruiseGlossaryMessages.cabinInside),
    oceanview: intl.formatMessage(cruiseGlossaryMessages.cabinOceanview),
    window: intl.formatMessage(cruiseGlossaryMessages.cabinWindow),
    oceanview_window: intl.formatMessage(cruiseGlossaryMessages.oceanviewOrWindow),
    balcony: intl.formatMessage(cruiseGlossaryMessages.cabinBalcony),
    suite: intl.formatMessage(cruiseGlossaryMessages.cabinSuite),
  }
}

export default useCruiseCabinTypeLabels
